import { api } from './client';
import type { NotificationPage } from '../types/api';

export interface ListNotificationsParams {
  beforeId?: string;
  limit?: number;
  unreadOnly?: boolean;
}

export async function listNotifications(
  params: ListNotificationsParams = {},
): Promise<NotificationPage> {
  const { data } = await api.get<NotificationPage>('/notifications', { params });
  return data;
}

export async function unreadCount(): Promise<number> {
  const { data } = await api.get<{ unread: number }>('/notifications/unread-count');
  return data.unread;
}

export async function markRead(body: { ids?: string[]; markAll?: boolean }): Promise<number> {
  const { data } = await api.post<{ updated: number }>('/notifications/mark-read', body);
  return data.updated;
}
